export const CUSTOM_CHART_BLOCK_TYPE = 'CUSTOM_CHART'
export const CUSTOM_CHART_BLOCK_TITLE = 'Custom Chart'

/** @returns {import('./config.types').CustomChartBlockConfig} */
export const defaultCustomChartBlockConfig = () => ({
  type: 'bar',
  data: [],
  title: 'Overall Grading',
  legend: true
})
